import { Component, ElementRef, ViewChild, Output, EventEmitter, Input, OnChanges, SimpleChanges, TemplateRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../services/commen/commen.services';
import { appService } from '../../../_services/app.service';

@Component({
  selector: 'app-file-upload-box',
  templateUrl: './file-upload-box.component.html',
  styleUrls: ['./file-upload-box.component.scss']
})
export class FileUploadBoxComponent implements OnChanges {
  @Output() outputKeyword: EventEmitter<any> = new EventEmitter();
  @Output() onDelete: EventEmitter<any> = new EventEmitter();
  @Input() listOfFile: any[];
  @Input() inputId: string;
  @Input() inputName: string;
  @Input() isDirectUploadFile: boolean = false;
  @Input() isMultipleFile: boolean = false;
  @Input() isButton: boolean = false;
  @Input() label: string;
  @ViewChild('imgView') imgViewTemplate: TemplateRef<any>;
  @ViewChild('fileInput') fileInput: ElementRef;

  modalRef: any;
  fileDetails: any = {};
  selectDocForView: any;
  constructor(private toastr: ToastrService, private commonService: CommonService,
    private translate: TranslateService, private modalService: NgbModal, private _appService: appService,
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.isMultipleFile && this.listOfFile && this.listOfFile.length) {
      this.fileDetails = this.listOfFile[0];
    }
  }

  openImgView(data) {
    this.modalRef = this.modalService.open(this.imgViewTemplate);
    this.selectDocForView = data;
  }

  onFileSelected(event: any): void {
    const files = (event.target as HTMLInputElement).files;
    console.log("Files selected:", files);
    if (this.isDirectUploadFile) {
      this.outputKeyword.emit(event);
      return;
    }
    if (!files || files.length === 0) {
      this.toastr.error(this.translate.instant("FileUpload.Selectfileupload"), "error");
      return;
    }
    if (!this.isMultipleFile && files.length > 1) {
      this.toastr.error(this.translate.instant("FileUpload.Selectsinglefile"), "error");
      return
    }
    for (const file of Array.from(files)) {
      if (this.commonService.isValidFileTypeV2(file) && this.commonService.isFileSizeExceeded(file) && this.commonService.isValidFileName(file)) {
        this.listOfFile = this.listOfFile && this.listOfFile.length && this.isMultipleFile ? this.listOfFile : [];
        this.createUrlforDoc(file).then((url) => {
          this.listOfFile.push({ name: file.name, url: url });
        });
        this.outputKeyword.emit(event);
      } else {
        this.fileInput.nativeElement.value = '';
      }
    }

  }

  private createUrlforDoc(file: File): Promise<string> {
    return new Promise<string>((resolve) => {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        resolve(e.target.result);
        this.fileDetails.path = e.target.result;
      };
      reader.readAsDataURL(file);
    });
  }

  removeImg() {
    this.fileDetails.path = null;
    this.fileInput.nativeElement.value = '';
    this.onDelete.emit(null);
  }

  onCancel(file: any) {
    const index = this.listOfFile.findIndex(x => x.name === file.name);
    if (index !== -1) {
      this.listOfFile.splice(index, 1);
      this.onDelete.emit(file);
    }
  }

}
